import { createReducer } from 'src/helpers/reducer';
import actionsTypes from './actionTypes';
import { IAgenciesState, ILoadDataSuccessPayload } from './types';

const initState: IAgenciesState = {
  isAgenciesLoading: false,
  agencies: undefined,
  agenciesFilteredTotal: undefined,
  agenciesTotal: undefined,
  allAvailableAgencies: undefined,
  allAvailableAgenciesFilteredTotal: undefined,
  allAvailableAgenciesTotal: undefined,
  isAllAvailableAgenciesLoading: false,
};

function onLoadAgenciesRequest(state: IAgenciesState): IAgenciesState {
  return {
    ...state,
    isAgenciesLoading: true,
  };
}

function onLoadAgenciesSuccess(
  state: IAgenciesState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IAgenciesState {
  const { agencies, total, filteredTotal } = payload;

  return {
    ...state,
    agencies,
    agenciesFilteredTotal: filteredTotal,
    isAgenciesLoading: false,
    agenciesTotal: total,
  };
}

function onLoadAgenciesError(state: IAgenciesState) {
  return {
    ...state,
    isAgenciesLoading: false,
  };
}

function onLoadAllAvailableAgenciesError(state: IAgenciesState) {
  return {
    ...state,
    isAllAvailableAgenciesLoading: false,
  };
}

function onLoadAllAvailableAgenciesRequest(state: IAgenciesState): IAgenciesState {
  return {
    ...state,
    isAllAvailableAgenciesLoading: true,
  };
}

function onLoadAllAvailableAgenciesSuccess(
  state: IAgenciesState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IAgenciesState {
  const { agencies, total, filteredTotal } = payload;

  return {
    ...state,
    allAvailableAgencies: agencies,
    isAllAvailableAgenciesLoading: false,
    allAvailableAgenciesFilteredTotal: filteredTotal,
    allAvailableAgenciesTotal: total,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_AGENCIES_REQUEST]: onLoadAgenciesRequest,
  [actionsTypes.LOAD_AGENCIES_SUCCESS]: onLoadAgenciesSuccess,
  [actionsTypes.LOAD_AGENCIES_ERROR]: onLoadAgenciesError,
  [actionsTypes.LOAD_ALL_AVAILABLE_AGENCIES_REQUEST]: onLoadAllAvailableAgenciesRequest,
  [actionsTypes.LOAD_ALL_AVAILABLE_SUCCESS]: onLoadAllAvailableAgenciesSuccess,
  [actionsTypes.LOAD_ALL_AVAILABLE_ERROR]: onLoadAllAvailableAgenciesError,
  [actionsTypes.CLEAR_STORE]: onClearStore,
});
